import React, { Component } from 'react'
import axios from 'axios';
import Layout from './Layout';
import { Button, Input, Breadcrumb, message, Spin } from 'antd';
import { getHeaderWithToken } from '../helpers/func';
import { SERVER_URL } from '../api';

const { TextArea } = Input;

// Edits Api/config/features.json directly instead of nano-ing it on the live
// server. Saving writes the same content to both the live config the API
// reads from and the public /uploads copy the mobile app falls back to —
// see Api/routes/admin/features.js for why both need to match.
class FeaturesConfig extends Component {

    constructor(props) {
        super(props)
        this.state = {
            raw: '',
            loading: true,
            saving: false,
            dirty: false,
            error: null,
        }
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        this.setState({ loading: true, error: null });
        axios({
            method: 'GET',
            url: `${SERVER_URL}v1/features-config`,
            headers: getHeaderWithToken(),
        }).then((response) => {
            this.setState({ raw: response.data.raw, loading: false, dirty: false });
        }).catch((error) => {
            const msg = (error.response && error.response.data && error.response.data.message) || 'Failed to load features.json';
            this.setState({ loading: false, error: msg });
            message.error(msg);
        });
    }

    save = () => {
        this.setState({ saving: true });
        axios({
            method: 'POST',
            url: `${SERVER_URL}v1/features-config`,
            headers: getHeaderWithToken(),
            data: { raw: this.state.raw },
        }).then(() => {
            message.success('Saved — live config and mobile fallback both updated.');
            this.setState({ saving: false });
            // Reload so the textarea reflects the server's canonical (re-formatted) copy
            this.load();
        }).catch((error) => {
            const msg = (error.response && error.response.data && error.response.data.message) || 'Failed to save features.json';
            this.setState({ saving: false });
            message.error(msg);
        });
    }

    render() {
        let { raw, loading, saving, dirty, error } = this.state;

        return (
            <Layout>
                <div className="content-box supplies-page">
                    <div className="bredcrumb-div">
                        <Breadcrumb separator="-">
                            <Breadcrumb.Item><span>Features Config</span></Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <div className="page-title d-flex">
                        <h2>Features Config</h2>
                        <div>
                            <Button onClick={this.load} disabled={loading || saving} style={{ marginRight: 8 }}>Reload</Button>
                            <Button
                                onClick={this.save}
                                type="primary"
                                className="primary-btn"
                                disabled={loading || saving || !dirty}
                                loading={saving}
                                style={{ minWidth: 170 }}
                            >
                                Save
                            </Button>
                        </div>
                    </div>
                    <div className="page-content">
                        <p style={{ marginBottom: 12 }}>
                            Raw contents of <code>config/features.json</code>. Saving must produce valid JSON —
                            invalid JSON is rejected before anything on disk is touched. The previous version is
                            backed up to <code>config/features_backup.json</code> on every save.
                        </p>
                        {error && <p style={{ color: '#cf1322' }}>{error}</p>}
                        {loading ? (
                            <Spin />
                        ) : (
                            <TextArea
                                value={raw}
                                onChange={(e) => this.setState({ raw: e.target.value, dirty: true })}
                                autoSize={{ minRows: 24, maxRows: 60 }}
                                style={{ fontFamily: 'monospace', fontSize: 13 }}
                                spellCheck={false}
                            />
                        )}
                    </div>
                </div>
            </Layout>
        )
    }
}

export default FeaturesConfig;
